import identity from '@/locales/es/identity/identity.locales';
import roles from '@/locales/es/identity/roles.locales';

export default {
    ...roles,
    ...identity,
};
